import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

/**
 * SPAT patient self-report form entrypoint.
 *
 * The SPAT form groups 8 sensory systems as separate questions, each with many subquestions.
 * We pass `formKey="spat"` explicitly so the template binds to the correct stored form.
 */
export default function PatientSPATForm() {
  return (
    <PatientFormTemplate
      formTitle="Sensory Profile Assessment Tool (SPAT)"
      formKey="spat"
    />
  );
}

